import React, { useState } from 'react';

type SetFormHasHadDataSetAtLeastOnce = React.Dispatch<React.SetStateAction<boolean>>;
const FormHasHadDataSetAtLeastOnceContext = React.createContext<boolean>(false);
const SetFormHasHadDataSetAtLeastOnceContext = React.createContext<
    SetFormHasHadDataSetAtLeastOnce | undefined
>(undefined);

export function FormHasHadDataSetAtLeastOnceProvider(props: {
    children: React.ReactElement;
}): React.ReactElement {
    const [formHasHadDataSetAtLeastOnceContext, setFormHasHadDataSetAtLeastOnceContext] = useState(
        false
    );
    return (
        <SetFormHasHadDataSetAtLeastOnceContext.Provider
            value={setFormHasHadDataSetAtLeastOnceContext}
        >
            <FormHasHadDataSetAtLeastOnceContext.Provider
                value={formHasHadDataSetAtLeastOnceContext}
            >
                {props.children}
            </FormHasHadDataSetAtLeastOnceContext.Provider>
        </SetFormHasHadDataSetAtLeastOnceContext.Provider>
    );
}

export function useFormHasHadDataSetAtLeastOnceContext(): boolean {
    return React.useContext(FormHasHadDataSetAtLeastOnceContext);
}

export function useSetFormHasHadDataSetAtLeastOnceContext(): SetFormHasHadDataSetAtLeastOnce {
    const val = React.useContext(SetFormHasHadDataSetAtLeastOnceContext);
    if (!val)
        throw new Error(
            'Unexpectedly did not find event panel form has had data set setter on context'
        );
    return val;
}
